"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateGlobalRecurringDateConfigs = exports.generateDateListFromRecurringDateConfig = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const generate_1 = require("../generate");
const generateDateListFromRecurringDateConfig = (params) => {
    const { recurringDateConfig, supplementalVariables } = params;
    const { field, setup } = recurringDateConfig;
    const { type } = setup;
    // *** Manage static config ***
    if (setup.type === 'static') {
        const dateList = (0, generate_1.createDateListFromConfig)(setup.config, true);
        return { isValid: true, dateList };
    }
    // *** Manage relative config ***
    if (setup.type === 'relative') {
        const { triggerDateFormula, config } = setup;
        let triggerDate;
        try {
            const sanitizedFormula = triggerDateFormula.startsWith('=')
                ? triggerDateFormula.slice(1)
                : triggerDateFormula;
            triggerDate = formula_engine_1.commonFormulas.evaluateDateFormula({
                dateFormula: sanitizedFormula,
                variables: supplementalVariables,
            });
        }
        catch (error) {
            return {
                isValid: false,
                errors: [
                    `Incurred errors evaluating "triggerDateFormula" for [globalRecurringDateConfig:${field}]`,
                ],
            };
        }
        const dateList = (0, generate_1.createDateListFromRelativeConfig)(config, triggerDate, true);
        return { isValid: true, dateList };
    }
    return {
        isValid: false,
        errors: [`Incurred unexpected recurring date config type: [type:${type}]`],
    };
};
exports.generateDateListFromRecurringDateConfig = generateDateListFromRecurringDateConfig;
const evaluateGlobalRecurringDateConfigs = (params) => {
    const { globalRecurringDateConfigs, supplementalVariables, creditFacilitySlug, logFn, } = params;
    const recurringDateResults = [];
    const errors = [];
    for (const recurringDateConfig of globalRecurringDateConfigs) {
        const { field, maxCount, defaultTo } = recurringDateConfig;
        // Evaluate "setup" (recurring date config) to generate list of all the
        // associated fullDateStr
        const dateListResults = (0, exports.generateDateListFromRecurringDateConfig)({
            recurringDateConfig,
            supplementalVariables,
        });
        if (!dateListResults.isValid) {
            return {
                variables: [],
                errors: dateListResults.errors,
            };
        }
        const { dateList } = dateListResults;
        // Pre-emptively evaluate "defaultTo" config so have value available
        // since it'll be the same for all occurrences in this config instance
        const defaultValue = common_1.stringConversion.parseStringValueToSqlPrimitive(defaultTo);
        // Utilize "maxCount" to drive how many variables should actually be
        // added. If the generated dates don't output enough options, then
        // we resort to evaluated "defaultTo" value, per above
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < maxCount; idx += 1) {
            const name = `${field}${(0, formula_engine_1.generateVarIdxSuffix)(idx)}`;
            const value = idx >= dateList.length ? defaultValue : dateList[idx];
            recurringDateResults.push({ name, value });
        }
    }
    logFn === null || logFn === void 0 ? void 0 : logFn({
        message: `Completed evaluating Global Recurring Date Configs: [numVariables:${recurringDateResults.length}] [numErrors:${errors.length}] [cfSlug:${creditFacilitySlug}]`,
    }, finley_types_1.Log.LogLevel.Info);
    return { variables: recurringDateResults, errors };
};
exports.evaluateGlobalRecurringDateConfigs = evaluateGlobalRecurringDateConfigs;
//# sourceMappingURL=generate.js.map